module.exports = __webpack_public_path__ + "5be13afb891782e146011ccebabf2764.svg";